import { render, staticRenderFns } from "./GameSticks.vue?vue&type=template&id=d7acaa04&"
import script from "./GameSticks.vue?vue&type=script&lang=js&"
export * from "./GameSticks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports